export default __webpack_public_path__ + "static/media/Payroll-4.b5d27d49.png";